/**
 * @file storage/cookie
 * @author zhengtingting (zhengtingting@baidu.com)
 *
 * */
/* eslint-disable */

import _ from 'lodash';

const config = (key, value, options) => {
    // Write
    if (value !== undefined && !_.isFunction(value)) {
        options = _.extend({}, config.defaults, options);
        if (typeof options.expires === 'number') {
            const days = options.expires;
            const t = (options.expires = new Date());
            // 防止t 不存在、报错
            if (t && t.setDate) {
                t.setDate(t.getDate() + days);
            }
        }
        const res = [];
        res.push(`${encode(key)}=${stringfyCookieValue(value)}`);
        options.expires && res.push(`expires=${options.expires.toUTCString()}`);
        options.path && res.push(`path=${options.path}`);
        options.domain && res.push(`domain=${options.domain}`);
        options.secure && res.push(`secure=${options.secure}`);
        return (document.cookie = res.join('; '));
    }

    // Read
    let result = key ? undefined : {};

    const cookies = document.cookie ? document.cookie.split('; ') : [];

    for (let i = 0, len = cookies.length; i < len; i++) {
        const parts = cookies[i].split('=');
        const name = decode(parts.shift());
        let cookie = parts.join('=');

        if (key && key === name) {
            // If second argument (value) is a function it's a converter...
            result = read(cookie, value);
            break;
        }

        // Prevent storing a cookie that we couldn't decode.
        if (!key && (cookie = read(cookie)) !== undefined) {
            result[name] = cookie;
        }
    }

    return result;
};

const encode = str => (config.raw ? str : encodeURIComponent(str));

const decode = str => (config.raw ? str : decodeURIComponent(str));

const stringfyCookieValue = value =>
    encode(config.json ? JSON.stringify(value) : value.toString());

/**
 * parse cookie value
 * @param {string} str data
 * @return {string} parse data
 */
const parseCookieValue = str => {
    const pluses = /\+/g;
    if (str.indexOf('"') === 0) {
        // This is a quoted cookie as according to RFC2068, unescape...
        str = str
            .slice(1, -1)
            .replace(/\\"/g, '"')
            .replace(/\\\\/g, '\\');
    }

    try {
        // Replace server-side written pluses with spaces.
        // If we can't decode the cookie, ignore it, it's unusable.
        str = decodeURIComponent(str.replace(pluses, ' '));
    } catch (e) {
        return;
    }

    try {
        // If we can't parse the cookie, ignore it, it's unusable.
        return config.json ? JSON.parse(str) : str;
    } catch (e) {}
};

/**
 * read cookie value
 * @param  {string} str cookie
 * @param  {?Function} convert function
 * @return {string}   cookie value
 */
const read = (str, convert) => {
    const value = parseCookieValue(str);
    return _.isFunction(convert) ? convert(value) : value;
};

/**
 * get cookie
 * @param  {string} key name
 * @return {string} data
 */
export const get = key => config(key);

/**
 * set cookie
 * @param {string} key     name
 * @param {*} value   value
 * @param {?Object} options options
 *
 * @return {string} data
 */
export const set = (key, value, options) => config(key, value, options);

/**
 * delete cookie
 * @param  {string} key     name
 * @param  {?Object} options options
 * @return {boolean}         delete success or fail
 */
export const remove = (key, options) => {
    if (config(key) !== undefined) {
        config(
            key,
            '',
            Object.assign({}, options, {
                expires: -1
            })
        );
        return true;
    }
    return false;
};
